import {
  Component,
  ChangeDetectorRef,
  OnInit,
  OnDestroy
} from '@angular/core';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import {
  startOfDay,
  format,
  endOfMonth,
  startOfMonth,
  addMonths,
  isSameDay,
  getHours,
  getTime,
  getMinutes,
  addMinutes
} from 'date-fns';

import {TimeModel, TimeStoreModel} from './time.model';

import {State} from '../../reducers/index';
import {SHOW_HEADER, OVERLAY_START} from '../../actions/header.action';
import {DATA_REQUEST} from '../../actions/data.action';
import {APPOINTMENT_REQUEST} from '../../actions/appointment.action';
import {INFO_UPDATE, Info} from '../../actions/info.action';
import {Booking} from '../../actions/booking.action';

@Component({
  selector: 'consentz-time',
  templateUrl: './time.template.html',
  styleUrls: ['./time.styles.scss']
})
export class TimeComponent implements OnInit, OnDestroy {
  public model: TimeModel = new TimeModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  public storeData: TimeStoreModel = new TimeStoreModel();
  public userLocalTimes = [];
  public result = false;
  private dataForAppointment: Info;
  private timesData: any;
  private bookedTodayTime: any;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private store: Store<State>
  ) {
    // hide header, allow ovelay, get date and practitioner worktime request
    this.store.dispatch({type: SHOW_HEADER});
    this.store.dispatch({type: OVERLAY_START});
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/week`
      }
    });
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/calendar?start=${format(startOfMonth(localStorage.getItem('defaultDateValue')), 'YYYY-MM-DD')}&end=${format(endOfMonth(addMonths(localStorage.getItem('defaultDateValue'), 2)), 'YYYY-MM-DD')}`
      }
    });
    // subscribtion on widget options, server data with detach cotrolling
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
    this.storeData.model$ = store.select<any>('data');
    this.storeData.subscribtion.data$ = this.storeData.model$.subscribe((data) => {
      this.bookedTodayTime = [];
      if (data && data.practitionerEvents) {
        data.practitionerEvents.forEach((singleEvent) => {
          if (this.dataForAppointment && isSameDay(singleEvent.start, this.dataForAppointment.date)) {
            this.bookedTodayTime.push({
              start:
                `${getHours(new Date(singleEvent.start))}.` +
                `${
                  getMinutes(new Date(singleEvent.start)) < 10
                    ? '0' + getMinutes(new Date(singleEvent.start))
                    : getMinutes(new Date(singleEvent.start))
                }`
              ,
              end:
                `${getHours(new Date(singleEvent.end))}.` +
                `${
                  getMinutes(new Date(singleEvent.end)) < 10
                    ? '0' + getMinutes(new Date(singleEvent.end))
                    : getMinutes(new Date(singleEvent.end))
                }`});
          }
        });
      }
      // console.log(data.timeData);
      if (data.timeData) {
        this.timesData = {...data.timeData};
        this.userLocalTimes = [];
        let startWorking = new Date(this.timesData.start - (this.getTimeZone() * 60 * 1000) - 3600000);
        const timeCreation = (index: number) => {
          this.userLocalTimes.push({
            id: index,
            value:
              `${getHours(startWorking)}:` +
              `${
                getMinutes(startWorking) < 10
                  ? '0' + getMinutes(startWorking)
                  : getMinutes(startWorking)
              }`,
            status: false,
          });
          startWorking = addMinutes(startWorking, 15);
        };
        // console.log(this.timesData.minutes, this.timesData.time);
        for (let i = 0; i < Math.floor(this.timesData.minutes / 15); i++) {
          timeCreation(i);
        }
        const timePartsIds = [];
        this.timesData.parts
          .map((item) => {
            timePartsIds.push(item.id);
          });
        const workDayEnd = Number(this.userLocalTimes[0].value.split(':')[0]) * 60 + Number(this.userLocalTimes[0].value.split(':')[1]) + this.timesData.minutes;
        this.userLocalTimes = this.userLocalTimes.filter((item) => {
          let result = true;
          const testElementInMinutes = Number(item.value.split(':')[0]) * 60 + Number(item.value.split(':')[1]);
          const treatmentLength = this.timesData.time;
          const treatmentSchedule = testElementInMinutes + treatmentLength;

          if (treatmentSchedule > workDayEnd) {
            result = false;
          } else {
            for (let i = 0; i < this.bookedTodayTime.length; i++) {
              const startInMinutes = Number(this.bookedTodayTime[i].start.split('.')[0]) * 60 + Number(this.bookedTodayTime[i].start.split('.')[1]);
              const endInMinutes = Number(this.bookedTodayTime[i].end.split('.')[0]) * 60 + Number(this.bookedTodayTime[i].end.split('.')[1]);
              if (
                testElementInMinutes >= startInMinutes && testElementInMinutes < endInMinutes ||
                (treatmentSchedule > startInMinutes && testElementInMinutes < endInMinutes)
              ) {
                result = false;
                break;
              }
            }
          }
            return result;
        });
      }
      this.cdr.markForCheck();
    });
    // subscribtion on local selections
    this.storeData.info$ = store.select<any>('info');
    this.storeData.subscribtion.info$ = this.storeData.info$.subscribe((data: Info) => {
      this.dataForAppointment = data;
    });
  }

  // save time in store
  public selectTime(time: any, index: number): void {
    this.model.indexOfChosenTime = index;
    const timeInMinutes = Number(this.userLocalTimes[index].value.split(':')[0]) * 60 + Number(this.userLocalTimes[index].value.split(':')[1]) + this.getTimeZone();
    const someRoundHours = Math.floor(timeInMinutes / 60);
    const roundHoursToShow = `${Math.floor(timeInMinutes / 60)}`.length < 2 ? '0' + `${Math.floor(timeInMinutes / 60)}` : `${Math.floor(timeInMinutes / 60)}`;
    const someMinutes = ((timeInMinutes / 60) - someRoundHours) * 60;
    const minutesToShow = `${Math.floor(someMinutes)}`.length < 2 ? '0' + `${Math.floor(someMinutes)}` : `${Math.floor(someMinutes)}`;
    const dataToSend = {
      id: this.userLocalTimes[index].id,
      value: roundHoursToShow + ':' + minutesToShow,
      status: this.userLocalTimes[index].status
    };
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: {
        time: dataToSend,
        userLocalTime: time
      }
    });
  }

  // create appointment request
  public createAppointment(): void {
    this.model.disabledAfterPaymentForBlockingDoubleClick = true;
    this.store.dispatch({
      type: APPOINTMENT_REQUEST,
      payload: this.dataForAppointment
    });
    this.model.timeout = setTimeout(() => {
      this.model.disabledAfterPaymentForBlockingDoubleClick = false;
    }, 2000);
  }

  // detach changes
  public ngOnInit(): void {
    localStorage.removeItem('refresh');
  }

  // unsubscribe from store, clear changeDetectorRef timeout, detach changes
  public ngOnDestroy(): void {
    clearTimeout(this.model.timeout);
    clearTimeout(this.model.changeDetectorRefTimeout);
    this.storeData.subscribtion.booking$.unsubscribe();
    this.storeData.subscribtion.data$.unsubscribe();
    this.storeData.subscribtion.info$.unsubscribe();
  }

  // Get user timezone offset
  private getTimeZone = () => {
    let offset: any = new Date();
    offset = offset.getTimezoneOffset();
    return offset;
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/time/time.component.ts